import React, { useState } from 'react'
import styled from 'styled-components'

import { usePeer } from '../hooks/peer'

export default (props) => {
	const [code, set_code] = useState('')

	const { ready, join_room } = usePeer({ init: false, code })

	const handle_change = ({ target: { value } }) => {
		if (value.length < 5) set_code(value)
	}

	return (
		<Container>
			<Section top>
				<Input
					value={code}
					onChange={handle_change}
					autoComplete="off"
					autoCapitalize="off"
					maxLength={4}
					spellCheck={false}
				/>
				{!code && <Placeholder>____</Placeholder>}
				<Text top>{ready ? 'enter your code' : 'connecting'}</Text>
			</Section>
			<Section>
				<Button onClick={() => join_room()} disabled={!ready}>
					Join
				</Button>
			</Section>
		</Container>
	)
}

const Container = styled.section`
	height: 100%;
	display: flex;
	flex-direction: column;
`
const Section = styled.section<{ top? }>`
	flex: 1;
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: ${({ top }) => top && 'flex-end'};
	background: ${({ theme }) => theme.colors.white};
`
const Input = styled.input`
	font-size: 4rem;
	font-weight: 600;
	text-align: center;
	text-decoration: none;
	margin-bottom: 1.5rem;
	max-width: 70%;
	letter-spacing: 0.5rem;
	border: none;
	color: ${({ theme }) => theme.colors.primary};
	background: transparent;
	z-index: 2;

	:focus {
		outline: none;
	}
`
const Placeholder = styled.div`
	font-size: 4rem;
	font-weight: 600;
	text-align: center;
	margin-top: -6rem;
	margin-bottom: 1rem;
	letter-spacing: 0.3rem;
	color: ${({ theme }) => theme.colors.primary};
`
const Text = styled.p<{ top? }>`
	font-size: 1.1rem;
	color: ${({ theme }) => theme.colors.grey[1]};
	font-style: ${({ top }) => top && 'italic'};
`
const Button = styled.button`
	margin-top: 5rem;
	color: ${({ theme, disabled }) =>
		disabled ? theme.colors.grey[1] : theme.colors.primary};
	width: 170px;
	height: 50px;
	font-size: 1rem;
	border: 2px solid
		${({ theme, disabled }) =>
			disabled ? theme.colors.grey[1] : theme.colors.primary};
	outline: none;
	background: ${({ theme }) => theme.colors.white};
	cursor: pointer;

	:disabled {
		cursor: default;
	}

	:focus {
		outline: none;
		text-decoration: underline;
	}
`
